// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.features-section {
  width: 100vw;
  background: #f8fafc;
  padding: 64px 0;
  display: flex;
  justify-content: center;
}

.features-container {
  display: flex;
  align-items: center;
  max-width: 1200px;
  width: 95vw;
  gap: 48px;
}

.features-image {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  
}

.features-image img {
    width: 100%;
    max-width: 340px;
    border-radius: 24px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.08);/* Add this line to move image right */
}

.features-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.features-title {
  font-family: 'Montserrat', Arial, sans-serif;
  font-size: 2.5rem;
  font-weight: 900;
  color: #222;
  margin-bottom: 32px;
  letter-spacing: 1px;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-item {
  margin-bottom: 28px;
  padding-bottom: 18px;
  border-bottom: 1px solid #e5e7eb;
  animation: fadeInUp 0.7s;
}

.feature-item h3 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #4f7cff;
  margin-bottom: 8px;
  font-family: 'Montserrat', Arial, sans-serif;
}

.feature-item p {
  font-size: 1rem;
  color: #444;
  margin: 0;
  font-family: 'Montserrat', Arial, sans-serif;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(40px);}
  to { opacity: 1; transform: translateY(0);}
}

@media (max-width: 900px) {
  .features-container {
    flex-direction: column;
    gap: 32px;
    align-items: stretch;
  }
  .features-image img {
    max-width: 320px;
    margin-left: 0; /* Remove margin on tablet/mobile */
  }
  .features-title {
    font-size: 2rem;
  }
}

@media (max-width: 600px) {
  .features-section {
    padding: 32px 0;
  }
  .features-title {
    font-size: 1.5rem;
  }
  .features-image img {
    max-width: 90vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Features.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC,CAAC,sCAAsC;AAClF;;AAEA;EACE,SAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,CAAC;EAC/C,KAAK,UAAU,EAAE,wBAAwB,CAAC;AAC5C;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,cAAc,EAAE,mCAAmC;EACrD;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".features-section {\n  width: 100vw;\n  background: #f8fafc;\n  padding: 64px 0;\n  display: flex;\n  justify-content: center;\n}\n\n.features-container {\n  display: flex;\n  align-items: center;\n  max-width: 1200px;\n  width: 95vw;\n  gap: 48px;\n}\n\n.features-image {\n  flex: 1 1 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n}\n\n.features-image img {\n    width: 100%;\n    max-width: 340px;\n    border-radius: 24px;\n    box-shadow: 0 8px 32px rgba(0,0,0,0.08);/* Add this line to move image right */\n}\n\n.features-info {\n  flex: 1 1 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.features-title {\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-size: 2.5rem;\n  font-weight: 900;\n  color: #222;\n  margin-bottom: 32px;\n  letter-spacing: 1px;\n}\n\n.features-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.feature-item {\n  margin-bottom: 28px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid #e5e7eb;\n  animation: fadeInUp 0.7s;\n}\n\n.feature-item h3 {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #4f7cff;\n  margin-bottom: 8px;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.feature-item p {\n  font-size: 1rem;\n  color: #444;\n  margin: 0;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(40px);}\n  to { opacity: 1; transform: translateY(0);}\n}\n\n@media (max-width: 900px) {\n  .features-container {\n    flex-direction: column;\n    gap: 32px;\n    align-items: stretch;\n  }\n  .features-image img {\n    max-width: 320px;\n    margin-left: 0; /* Remove margin on tablet/mobile */\n  }\n  .features-title {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .features-section {\n    padding: 32px 0;\n  }\n  .features-title {\n    font-size: 1.5rem;\n  }\n  .features-image img {\n    max-width: 90vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
